module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-4.80235021.svg";